import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DiagnosticGlyph = /*#__PURE__*/createElement("g", {
  id: "Diagnostic"
}, /*#__PURE__*/createElement("path", {
  d: "M67.32,63.4l-12.3-12.3c-0.04-0.04-0.09-0.09-0.14-0.13c3.42-4.03,5.3-9.13,5.3-14.4c0-12.29-10-22.3-22.3-22.3 s-22.3,10-22.3,22.3c0,12.29,10,22.3,22.3,22.3c4.02,0,7.95-1.09,11.4-3.15c0.15,0.23,0.31,0.44,0.49,0.63l12.3,12.3 c0.7,0.7,1.63,1.09,2.62,1.09s1.92-0.39,2.62-1.09C68.77,67.2,68.77,64.84,67.32,63.4z M50.24,34.72l-2.81-8.63 c-0.25-0.78-0.98-1.28-1.81-1.27c-0.81,0.03-1.52,0.59-1.73,1.38L39.16,44.5l-5-12.57c-0.27-0.69-0.93-1.15-1.68-1.16 c-0.01,0-0.03,0-0.04,0c-0.73,0-1.38,0.43-1.68,1.1l-1.26,2.86H19.37c0.93-9.44,8.98-16.77,18.51-16.77s17.58,7.33,18.51,16.77 H50.24z M32.37,37.38l5.46,13.73c0.28,0.71,0.95,1.16,1.71,1.16l0.12,0c0.8-0.05,1.47-0.6,1.67-1.38l4.56-17.65l1.27,3.9 c0.25,0.76,0.95,1.27,1.75,1.27h7.5c-0.93,9.44-8.98,16.77-18.51,16.77s-17.58-7.33-18.51-16.77h11.34 C31.42,38.41,32.06,38.01,32.37,37.38z"
}));
const Diagnostic = createSvg({
  name: 'diagnostic',
  path: DiagnosticGlyph
});

export default Diagnostic;
export { DiagnosticGlyph };
